// The node's activation QR, encoded in the browser from erp-core's
// `qr_payload` (GET /v1/erp/license/qr) — the server sends text, never an
// image. One crisp SVG path, dark modules on white, 4-module quiet zone.
// Encoder: the repo's dependency-free QR encoder (booking's «رابط الحجز وQR»,
// verified there against a golden matrix). SHARED-REQUESTS asks the
// integrator to move it to src/lib; until then it is imported from booking.

import { useMemo } from 'react';
import { encodeQr, qrPath } from '@/features/booking/page/lib/qr-encode';

export interface QrMatrixSvgProps {
  value: string;
  label: string;
  className?: string;
  'data-testid'?: string;
}

export function QrMatrixSvg({ value, label, className, 'data-testid': testId }: QrMatrixSvgProps) {
  // ECC L: the smallest matrix for the payload — the board draws the QR at 56 px.
  const m = useMemo(() => encodeQr(value, { ecc: 'L' }), [value]);
  const box = m.size + 8;
  return (
    <svg
      className={className}
      role="img"
      aria-label={label}
      viewBox={`0 0 ${box} ${box}`}
      shapeRendering="crispEdges"
      data-testid={testId}
      data-qr-version={m.version}
      data-qr-payload={value}
    >
      <rect className="sys-qr-bg" width={box} height={box} />
      <path className="sys-qr-fg" d={qrPath(m, 4)} />
    </svg>
  );
}
